export enum MI_MULTIPLIER_SHARED_ATLAS_FRAMES {
  HERES = 'heres.png',
  KICKER = 'kicker.png',
  THE = 'the.png',
}

export enum MI_MULTIPLIER_SHARED_TEXTURE_KEYS {
  ATLAS = 'MI_MULTIPLIER_SHARED_ATLAS',
}
